import Terminal from './Terminal';

const Hero = () => {
  return (
    <header className="relative overflow-hidden hero-pattern min-h-screen flex items-center">
      <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm"></div>
      <div className="absolute inset-0 bg-grid-indigo-500/[0.05] bg-[size:20px_20px]"></div>
      <div className="relative w-full px-4 sm:px-6 lg:px-8 py-32">
        <Terminal />
      </div>
    </header>
  );
};

export default Hero;